



















































































import {Vue, Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {PoslovniPartner, Prijemnica, StavkaDokumenta} from "@/services/BackendProxies";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {formatPrice} from "@/utils/formatters";
import {focusCena} from "@/utils/focusFunctions";
import * as _ from 'lodash';

@Component({})
export default class UnosZaliha extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    prijemnica = Prijemnica.fromJS({stavke: [new StavkaDokumenta()], datum: new Date()});
    columns = [];

    total = 0;
    isBusy = false;
    rezDeloviByKataloski = [];
    rezDeloviByNaziv = [];

    async created() {
        this.columns = [
            {
                field: 'kataloskiBroj',
                title: this.$i18n.t('kataloskiBroj'),
                width: 250,
                formatter: this.kataloskiBrojFormatter
            },
            {field: 'opis', title: this.$i18n.t('nazivArtikla'), formatter: this.nazivArtiklaFormatter},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), width: 140, formatter: this.kolicinaFormatter},
            {field: 'cena', title: this.$i18n.t('cena'), width: 140, formatter: this.cenaFormatter},
            {field: 'iznos', title: this.$i18n.t('iznos'), width: 140, formatter: formatPrice},
            {field: 'action', align: 'right', width: 30, formatter: `<i class="fa fa-trash text-danger"></i>`}
        ];
    }

    typeAheadLoaderKataloski = async (params, success, failure) => {
        const rezDelovi = await dataProxy.vratiRezervneDelovePoKataloskomBroju(params.data.term);
        success(rezDelovi)
    };

    processResultsKataloski(data: any[]) {
        this.rezDeloviByKataloski = data;
        return {
            results: data.map((x) => ({id: x.kataloskiBroj, text: x.kataloskiBroj}))
        }
    }

    kataloskiBrojFormatter(value, row) {
        return this.vueFormatter({
            template: `<mf-type-ahead :loader="loader" :data="[row.kataloskiBroj]" :processResults="processResults" @input="onUnetKataloski(row)"
                            v-model="row.kataloskiBroj" ></mf-type-ahead>`,
            data: {row},
            methods: {loader: this.typeAheadLoaderKataloski, onUnetKataloski: this.onUnetKataloski,
                      processResults: this.processResultsKataloski}
        })
    }

    async onUnetKataloski(row) {
        const rezDeo = this.rezDeloviByKataloski.find(r => r.kataloskiBroj == row.kataloskiBroj);
        row.opis = (rezDeo ? rezDeo.naziv : '') || '';
    }

    typeAheadLoaderNazivArtikla = async (params, success, failure) => {
        const rezDelovi = await dataProxy.vratiRezervneDelovePoNazivu(params.data.term);
        success(rezDelovi);
    };

    processResultsNazivArtikla(data: any[]) {
        this.rezDeloviByNaziv = data;
        return {
            results: data.map((x) => ({id: x.naziv, text: x.naziv}))
        }
    }

    nazivArtiklaFormatter(value, row, index) {
        return this.vueFormatter({
            template: `<mf-type-ahead type="text" :loader="loader" :processResults="processResults" @input="onUnetNaziv(row)"
                       :class="{invalid: row.opis === undefined}" :data="[row.opis]"
                         v-model="row.opis"></mf-type-ahead>`,
            data: {row},
            methods: {loader: this.typeAheadLoaderNazivArtikla, onUnetNaziv: this.onUnetNaziv,
                      processResults: this.processResultsNazivArtikla}
        })
    }

    onUnetNaziv(row) {
        const rezDeo = this.rezDeloviByNaziv.find(x => x.naziv == row.opis);
        const kataloskiBroj = (rezDeo ? rezDeo.kataloskiBroj : '');
        if (kataloskiBroj) {
            row.kataloskiBroj = kataloskiBroj;
        }
    }

    kolicinaFormatter(value, row, index) {
        return this.vueFormatter({
            template: `<input v-model.number.lazy="row.kolicina" style="text-align: right" data-cena="${index}"
                        :class="{invalid: row.kolicina < 1 || isNaN(row.kolicina)}"
                        @change="focusCena($event, 'data-kolicina', 'cena')" class="form-control" >`,
            data: {row},
            methods: {focusCena: focusCena}
        })
    }

    cenaFormatter(value, row, index) {
        return this.vueFormatter({
            template: `<input v-model.number.lazy="row.cena"  @keypress.enter="dodajStavku" class="form-control"
                        :class="{invalid: row.cena < 1 || isNaN(row.cena)}"
                       style="text-align: right"  data-kolicina="${index}">`,
            data: {row},
            methods: {dodajStavku: this.dodajStavku}
        })
    }

    @Watch('prijemnica.stavke', {deep: true}) onStavkeChange(value: StavkaDokumenta[]) {
        value.forEach(s => {s.iznos = s.kolicina * s.cena;});
    }

    get ukupno() {
        return _.sumBy(this.prijemnica.stavke, s => (s.kolicina || 0) * (s.cena || 0));
    }

    async cellClick(field, value, row) {
        if (field === 'action') {
            this.prijemnica.stavke = this.prijemnica.stavke.filter(x => x != row);
            if (row.id) {
                await this.deleteData(() => dataProxy.obrisiStavkuDokumenta(row.id))();
            }
        }
    }

    novaPrijemnica() {
        this.prijemnica = Prijemnica.fromJS({stavke: [new StavkaDokumenta()], datum: new Date()});
        this.total = 0;
    }

    dodajStavku() {
        this.prijemnica.stavke.push(StavkaDokumenta.fromJS({iznos: 0}));
    }

    async vratiPrijemnicuPoId(id: number) {
        if (id) {
            const prijemnica = await this.loadData(() => dataProxy.vratiPrijemnicuPoId(id))();
            if (!prijemnica) {
                this.showInfo('dokument nije moguce ucitati')
            } else {
                this.prijemnica = prijemnica;
            }
        }
    }

    async sacuvajPrijemnicu() {
        if (this.isBusy) return;
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            this.srediStavke();
            try {
                this.isBusy = true;
                this.prijemnica = await this.saveData(() => dataProxy.sacuvajPrijemnicu(this.prijemnica))();
            } finally {
                this.isBusy = false;
            }
        } else {
            this.showError('nisu sva obavezna polja popunjena')
        }
    }

    async zakljuciPrijemnicu() {
        if (this.isBusy) return;

        if (this.total != this.ukupno) {
            this.showError('ukupan iznos se ne slaze');
            return;
        }
        const valid = await (<any>this.$refs.observer).validate();
        if (!valid) {
            this.showError('nisu sva obavezna polja popunjena')
        }
        this.srediStavke();
        try {
            this.isBusy = true;
            await this.saveData(() => dataProxy.zakljuciPrijemnicu(this.prijemnica))();
            this.novaPrijemnica();
        } finally {
            this.isBusy = false;
        }
    }

    postBody() {
        this.vueFormatterPostBody();
        const input = $('input.invalid');
        if (input.length) {
            this.$nextTick(() => input[0].focus());
        }
    }

    private srediStavke() {
        this.prijemnica.stavke = this.prijemnica.stavke.filter(x => x.opis && x.kolicina && x.cena);
    }

}
